import React from "react";

interface Props {
  label: string;
  description: string;
  children: React.ReactNode;
}

const FieldRow: React.FC<Props> = ({ label, description, children }) => {
  return (
    <div
      className="flex flex-col sm:flex-row gap-4 sm:gap-6 px-6 py-5
                 border-b border-blue-50 hover:bg-blue-50/20
                 transition-colors duration-150"
    >
      <div className="sm:min-w-[200px] sm:flex-shrink-0">
        <p className="text-sm font-semibold text-blue-950 mb-0.5">{label}</p>
        <p className="text-xs text-slate-400 leading-relaxed">{description}</p>
      </div>

      <div className="flex-1 min-w-0">{children}</div>
    </div>
  );
};

export default FieldRow;